import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PoleMapDto } from '../../../../models/pole-map.model';

@Component({
  selector: 'app-pole-map-full-details',
  templateUrl: './pole-map-full-details.component.html',
  styleUrls: ['./pole-map-full-details.component.scss'],
  standalone: false
})
export class PoleMapFullDetailsComponent implements OnInit {
  @Input() pole: PoleMapDto;
  @Output() imageClicked = new EventEmitter<string>();

  coordinatesCopied = false;

  ngOnInit(): void {
  }

  showMore() {
    var url = `/poles/edit/${this.pole.id}`;
    window.open(url, '_blank');
  }

  copyCoordinates(): void {
    const coordinates = `${this.pole.latitude}, ${this.pole.longitude}`;
    navigator.clipboard.writeText(coordinates).then(() => {
      this.coordinatesCopied = true;
      setTimeout(() => {
        this.coordinatesCopied = false;
      }, 1500);
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }

  openBuildingDetails() {
    var url = `/poles/edit/${this.pole.id}`;
    window.open(url, '_blank');
  }

  openBuildingsDetailsPage(id: number) {
    var url = `/buildings/edit/${id}`;
    window.open(url, '_blank');
  }

  onImageClick(imageUrl: string) {
    this.imageClicked.emit(imageUrl);
  }
}
